module.exports = __webpack_public_path__ + "img/mb.f34f6de0.svg";